// Images array for Works carousel (shani works)
export const worksImages = [];
for (let i = 1; i <= 26; i++) {
  // Skip image 13 as it doesn't exist
  if (i === 13) continue;
  worksImages.push(require(`../../assets/shani_works_${i}.webp`));
}

// Images array for student works carousel
export const studentWorksImages = [];
for (let i = 1; i <= 50; i++) {
  studentWorksImages.push(require(`../../assets/works_${i}.webp`));
}
